import { render, staticRenderFns } from "./express-info.vue?vue&type=template&id=9643c244&scoped=true"
import script from "./express-info.vue?vue&type=script&lang=js"
export * from "./express-info.vue?vue&type=script&lang=js"
import style0 from "./express-info.vue?vue&type=style&index=0&id=9643c244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9643c244",
  null
  
)

export default component.exports